import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7e3fb58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tir-pm-menu-layout-button__content" }
const _hoisted_2 = { class: "tir-pm-menu-layout-button__left" }
const _hoisted_3 = { class: "tir-pm-menu-layout-button__middle" }
const _hoisted_4 = { class: "tir-pm-menu-layout-button__right" }


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-menu-layout-button',
  props: {
  /**Выбранная кнопка */
  isSelected: {
    type: Boolean,
    default: false,
  },
  /**Обрезать ли текст */
  textOverflow: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

// #region definProps

// #endregion definProps

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'tir-pm-menu-layout-button',
      { 'is-selected': __props.isSelected, 'text-overflow': __props.textOverflow },
    ])
  }, [
    _renderSlot(_ctx.$slots, "content", {}, () => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "left")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "right")
        ])
      ])
    ])
  ], 2))
}
}

})